module.exports = __webpack_public_path__ + "static/img/landing-screen-4.0e3b895.svg";